import React from 'react';

import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import {
	Box,
	TextField,
	IconButton,
	Divider,
	Typography,
	Switch,
} from '@mui/material';

import {
	IOptionListProps,
	IOptionData,
} from 'src/features/questionnaire_template/domain/types';

export const OptionList: React.FC<IOptionListProps> = ({
	options,
	onChange,
	validation = [],
}) => {
	const handleChange = (
		index: number,
		key: keyof IOptionData,
		value: string | boolean,
	) => {
		const shouldRemoveLabel = key === 'allow_text' && !value;

		const newOptions = [...options];

		// The order is important here so that when label is changed it is not overriden by label key logic below.
		newOptions[index] = {
			...newOptions[index],
			label: shouldRemoveLabel ? '' : newOptions[index].label,
			[key]: value,
			is_updated: true,
		};
		onChange(newOptions);
	};

	const handleDelete = (index: number, BE_ID?: number) => {
		if (BE_ID === undefined) {
			const updated = options.filter((_, i) => i !== index);
			onChange(updated);
		} else {
			const updated = options.map((opt) =>
				opt.id === BE_ID ? { ...opt, is_deleted: true } : opt,
			);
			onChange(updated);
		}
	};

	return (
		<>
			{options.map((option, index) => {
				if (option.is_deleted) return null;

				return (
					<React.Fragment key={index}>
						<Box
							sx={{
								display: 'flex',
								alignItems: 'center',
								gap: 1,
								mb: 1,
							}}
						>
							<RadioButtonUncheckedIcon
								sx={{ fontSize: 18, mr: 1 }}
							/>
							<TextField
								variant='standard'
								placeholder='Option text'
								value={option.value}
								onChange={(e) =>
									handleChange(index, 'value', e.target.value)
								}
								sx={{
									flex: 1,
									borderBottom: '1px dashed #ccc',
								}}
								InputProps={{
									disableUnderline: true,
								}}
								error={!!validation[index]?.value}
								helperText={validation[index]?.value || ''}
							/>

							<IconButton
								onClick={() => handleDelete(index, option.id)}
							>
								<img
									src='/delete.svg'
									alt='delete'
									width={16}
									height={18}
								/>
							</IconButton>

							<Divider orientation='vertical' flexItem />

							<Typography fontSize='14px'>Allow Text</Typography>
							<Switch
								size='small'
								checked={option.allow_text}
								onChange={(e) =>
									handleChange(
										index,
										'allow_text',
										e.target.checked,
									)
								}
								sx={{
									'& .MuiSwitch-switchBase.Mui-checked': {
										color: '#E53326',
									},
									'& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track':
										{
											backgroundColor: '#E53326',
										},
								}}
							/>
						</Box>

						{option.allow_text && (
							<Box sx={{ pl: 3, width: '100%' }}>
								<TextField
									variant='outlined'
									placeholder='Label for text input'
									value={option.label || ''}
									onChange={(e) =>
										handleChange(
											index,
											'label',
											e.target.value,
										)
									}
									size='small'
									fullWidth
									sx={{
										mb: 2,
										'& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':
											{
												borderColor: '#BE3327',
											},
										'& .MuiInputLabel-root.Mui-focused': {
											color: '#BE3327',
										},
									}}
									error={!!validation[index]?.label}
									helperText={validation[index]?.label || ''}
								/>
							</Box>
						)}
					</React.Fragment>
				);
			})}
		</>
	);
};
